import { Box } from '@mui/material'
import { LuBellRing } from 'react-icons/lu'

/**
 * Selo de pendências exibido no canto superior direito dos cards de módulo.
 * Fica oculto quando o contador é zero.
 */
const PendingBadge = ({ count = 0, moduleName }) => {
  if (!count) return null

  return (
    <Box
      title={`${count} pendência(s) em ${moduleName}`}
      sx={{
        position: 'absolute',
        top: -18,
        right: -8,
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        height: 36,
        px: 1.5,
        borderRadius: '999px',
        background: 'linear-gradient(135deg, #ef5350 0%, #c62828 100%)',
        color: '#fff',
        fontWeight: 'bold',
        fontSize: '0.95rem',
        lineHeight: 1,
        border: '2px solid #fff',
        boxShadow: '0 4px 12px rgba(183, 28, 28, 0.45)',
        zIndex: 10,
        '@keyframes pendingPulse': {
          '0%': { boxShadow: '0 0 0 0 rgba(211, 47, 47, 0.55)' },
          '70%': { boxShadow: '0 0 0 10px rgba(211, 47, 47, 0)' },
          '100%': { boxShadow: '0 0 0 0 rgba(211, 47, 47, 0)' },
        },
        animation: 'pendingPulse 2.4s ease-out infinite',
      }}>
      <LuBellRing size={20} />
      {count}
    </Box>
  )
}

export default PendingBadge
